var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"La familia","audio2":"../mp3/PrimariaA/03PA.mp3","cover":"../img/1.jpg","name":"Primaria A - Lección #3"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }